import * as React from 'react';
import { Provider } from 'react-redux';
import { createFormStore } from 'sos-eservice-common/js/Redux/store.provider';
import ResearchOrderFrom from './ResearchOrderForm';
import { ResearchOrderProps } from './ResearchOrder.types';
import { researchOrderStepValidationMap } from './researchOrderStepValidationMap';
import {setFormConfig} from 'sos-eservice-common/js/config';
import {ResearchConfig} from './researchConfig';
import { getInitialState } from './init';

export class ResearchOrder extends React.Component<ResearchOrderProps, any> {
  private store: ReturnType<typeof createFormStore>;

  constructor(props) {
    super(props);
    const {basePath, translations} = this.props;
    setFormConfig(new ResearchConfig(translations, basePath, researchOrderStepValidationMap));
    const initialState = getInitialState(this.props);
    this.store = createFormStore(initialState);
  }
  render() {
    return (
      <Provider store={this.store}>
        <ResearchOrderFrom />
      </Provider>
    );
  }
}
